var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pdp.product.timingOnboardTime)?_c('p',{staticClass:"ua-is-stock-tips"},[_vm._v("商品尚未发售")]):_c('p',{staticClass:"ua-is-stock-tips"},[_vm._v("抱歉，该商品已下架")])}
var staticRenderFns = []

export { render, staticRenderFns }